module.exports = __webpack_public_path__ + "static/media/8.4cf761b9.png";